import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IndianCurrencyPipe } from './pipes/indiancurrencypipe';
import { SumByKeyPipe } from './pipes/sumbykeypipe';
import { FilterPipe } from '../custome-filterpipe';

@NgModule({
    declarations: [
        FilterPipe,
        IndianCurrencyPipe, // ✅ declare your pipe
        SumByKeyPipe
    ],
    imports: [
        CommonModule
    ],
    exports: [
        FilterPipe,
        IndianCurrencyPipe,
        SumByKeyPipe // ✅ export so other modules can use it
    ]
})
export class SharedModule { }